import { observable, action } from "mobx";
import { CompositionService } from "modules/composition/CompositionService";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { BenchCompositionFile } from "modules/composition/models/BenchCompositionFile";
import { BenchCompositionItems } from "modules/composition/models/BenchCompositionItems";
import axios from "axios";

class Store {
  @observable benchComposition: FirebaseDocument<BenchCompositionFile>;
  // @observable groups: Array<FirebaseDocument<RateLibraryGroups>>;
  @observable groups: any = [];
  @observable group;
  @observable groupSublevel;
  @observable rateTasks: any = [];
  @observable rateTask;
  tasks: any = [];
  @observable items: Array<FirebaseDocument<BenchCompositionItems>>;
  @observable loading: boolean;
  @observable carregando: boolean;
  @observable lastIdLoaded: any = [];
  @observable resource: any = [];
  @observable _idArrayTemp: any = [];
  compositionGroupScrollTopObj: object = {}; // armazena a posição do scroll da tabela no componente GroupContent

  resetStore() {
    this.benchComposition = undefined as any;
    this.groups = [];
    this.group = undefined;
    this.groupSublevel = undefined;
    this.rateTasks = [];
    this.rateTask = undefined;
    this.tasks = [];
    this.items = new Array<FirebaseDocument<BenchCompositionItems>>();
    this.loading = false;
    this.carregando = false;
  }

  /**
   * @param {string} taskId - id da task
   * @param {number} scrollTop - Posição do scroll na tabela
   */
  setCompositionGroupScrollTopObj(
    taskId: string | null = null,
    scrollTop: number | null = null
  ) {
    if (taskId !== null && scrollTop !== null) {
      CompositionStore.compositionGroupScrollTopObj[taskId] = scrollTop;
      return;
    }
    CompositionStore.compositionGroupScrollTopObj = {};
  }
  /**
   * @param {string} taskId - id da task
   * @returns {number} O valor para qual o scroll na tabela deve ser indexado
   */
  getCompositionGroupScrollTopObj(taskId: string): number {
    const scrollTop = CompositionStore.compositionGroupScrollTopObj[taskId];
    return scrollTop;
  }
  @action
  setGroup(lvl) {
    let {
      data: { description, initial, tasks, sublevel },
    } = lvl;
    this.group = { description, initial, tasks };
    this.groupSublevel = sublevel;
    CompositionStore.rateTask = false;
  }

  @action
  async getBenchCompositionFile(id): Promise<void> {
    let benchComposition = await CompositionService.getBenchCompositionFile(id);
    if (benchComposition) this.benchComposition = benchComposition;
  }

  @action
  async getRootGroups(id): Promise<void> {
    let groupTmp = [...this.groups];
    await CompositionService.getRootGroups(id, groupTmp);
    this.groups = groupTmp;
  }
  @action
  async getGroupsByParent(id, array): Promise<void> {
    await CompositionService.getGroupsByParent(id, array);
  }
  @action
  async getRateTask(id) {
    let task = this.tasks.find((item) => item.id === id);
    if (!task) task = await CompositionService.getTaskById(id);
    if (task) {
      this.tasks.push(task);
      return task;
    }
    return null;
  }

  /** Obtém as composições de um grupo e atualiza a lista
   * de rateTasks e tasks da Store.
   */
  @action
  async getRateTasksByGroup(idArray, isTask = false): Promise<void> {
    let taskTmp = [...this.tasks];
    this.rateTasks = [];
    this.loading = idArray;

    let groupId = this.benchComposition.id + "-" + this.group.initial;
    let groupTasks_ = await CompositionService.getTasksByGroup(groupId);

    // Se trocar de tela para de carregar
    if (this.loading != idArray && isTask !== true) return;
    taskTmp = groupTasks_;
    this.rateTasks = groupTasks_;
    this.tasks = taskTmp;
    this.loading = false;
  }

  @action
  async getRateTasks(idArray, isTask = false): Promise<void> {
    let taskTmp = [...this.tasks];
    let rateTasks: any = [];
    this.rateTasks = [];
    this.loading = idArray;
    this._idArrayTemp = idArray;

    for (let id of idArray) {
      // Se trocar de tela para de carregar
      if (this.loading != idArray && isTask !== true) return;
      let task = taskTmp.find((item) => item.id === id);
      if (!task) {
        task = await CompositionService.getTaskById(id);
        task && taskTmp.push(task);
      }
      if (task) {
        if (this.rateTask) {
          let copyTask = { ...task },
            cmpstn = this.rateTask.data.composition.find(
              (itm) => itm.reference === task.id
            );
          if (cmpstn) {
            copyTask.data.finalCost = cmpstn.totalCost;
            copyTask.data.coefficient = cmpstn.coefficient;
            copyTask.data.unityCost = cmpstn.unityCost;
          }
          rateTasks.push(copyTask);
        } else rateTasks.push(task);
      }
    }
    // Se trocar de tela para de carregar
    if (this.loading != idArray && isTask !== true) return;

    this.rateTasks = rateTasks;
    this.tasks = taskTmp;
    this.loading = false;
  }
  @action
  setTooltipStyle() {
    let sideNames: any = Array.from(
      document.getElementsByClassName("sideName")
    );
    for (let node of sideNames)
      if (node && node.scrollWidth > node.clientWidth)
        node.style.pointerEvents = null;
      else node.style.pointerEvents = "none";
  }
  @action
  async getResources(rateLibrariesId): Promise<void> {
    this.resource = await CompositionService.getResources(rateLibrariesId);
  }

  //
  async setTaskById(
    fileId,
    id,
    rateTask,
    coefficient,
    textUnit,
    textTotal,
    editCoefficient,
    editUnitCost
  ): Promise<boolean> {
    this.loading = true;
    let aux: boolean = false;

    let unitCostFormatted = parseFloat(textUnit.replace(",", "."));

    await axios
      .post(`${process.env.REACT_APP_UPDATE_RESOURCES}`, {
        id: fileId,
        composition: rateTask,
        itemToUpdate: id,
        coefficient: coefficient,
        unitCost: unitCostFormatted,
      })
      .then(async (response) => {
        aux = true;
        // As funções getRateTasksByGroup e getRateTasks são chamadas aqui para recarregar os dados atualizados do banco.
        await this.getRateTasksByGroup(CompositionStore.group.tasks);
        await this.getRateTasks(this._idArrayTemp, true);
      })
      .catch((error) => {
        aux = false;
      });
    return aux;
  }

  async setResourceById(fileId, id, textUnit) {
    this.loading = true;
    await axios.post(`${process.env.REACT_APP_UPDATE_RESOURCE}`, {
      fileId: fileId,
      id: id,
      textUnit: textUnit,
    });

    this.loading = false;
  }

  batchActions = async (
    actions,
    needLoad,
    update = true,
    callback: Function = async () => {}
  ) => {
    if (needLoad == true) {
      this.loading = false;
    }
    let chunk = 400;
    for (let i = 0; i < actions.length; i += chunk) {
      let sliced = actions.slice(i, i + chunk);
      await CompositionService.batch(sliced)
        .then(async () => {
          for (let { arrayChange } of sliced) {
            if (arrayChange) await arrayChange();
          }
          await callback();
        })
        .catch((error) => console.log(error));
    }
    if (needLoad == true) {
      this.loading = true;
    }
  };
}

let CompositionStore = new Store();

export { CompositionStore };



// WEBPACK FOOTER //
// ./src/modules/composition/CompositionStore.tsx